/* Suprimal review engine. The review dialog hands each review to this script; it fills the hidden Shopify Forms
   form (Product reviews), submits it, and Shopify Flow publishes it as a review on the site. If Forms can't be
   reached, the review is sent by email through the contact form instead, so none are lost.
   Speed: the Forms form is no longer part of every page (its scripts cost phones about 1 MB of JavaScript). It is fetched
   the moment a shopper opens the review dialog, from a bare copy of the Reviews page (/pages/reviews?view=rwengine),
   and placed here hidden, exactly as before. */
(function () {
  'use strict';
  if (window.SPReviewEngine) return;
  var FORM_ID = '1163603';
  var busy = false;
  var seen = { ok: 0, bad: 0 };

  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function poll(fn, ms, step) {
    return new Promise(function (res, rej) {
      var t0 = Date.now();
      (function tick() {
        var v = null;
        try { v = fn(); } catch (e) {}
        if (v) return res(v);
        if (Date.now() - t0 > ms) return rej(new Error('timeout'));
        setTimeout(tick, step || 150);
      })();
    });
  }

  function host() {
    return document.querySelector('[data-forms-id="forms-root-' + FORM_ID + '"] shopify-forms-embed') ||
      document.querySelector('[data-sp-rw-engine] shopify-forms-embed') || document.querySelector('shopify-forms-embed');
  }
  function root() { var h = host(); return h && h.shadowRoot; }
  function q(sel) { var r = root(); return r ? r.querySelector(sel) : null; }
  function field(key) { return q('[id="' + key + '"]') || q('[name="' + key + '"]'); }
  function formEl() { var e = field('email'); return e ? e.closest('form') : q('form'); }

  /* bring in the hidden Forms form on demand: its markup and Forms' own scripts, read from the bare engine page */
  var ENGINE_URL = (window.spRwEngineUrl || '/pages/reviews') + (/\?/.test(window.spRwEngineUrl || '') ? '&' : '?') + 'view=rwengine';
  var booting = null;
  function boot() {
    if (document.querySelector('[data-forms-id="forms-root-' + FORM_ID + '"]')) return Promise.resolve();
    if (booting) return booting;
    booting = fetch(ENGINE_URL, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('engine ' + r.status);
      return r.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var rootEl = doc.querySelector('[data-forms-id="forms-root-' + FORM_ID + '"]') || doc.querySelector('[data-form-root]');
      if (!rootEl) throw new Error('no-form');
      if (document.querySelector('[data-forms-id="forms-root-' + FORM_ID + '"]')) return;
      var block = rootEl.closest('.shopify-block') || rootEl;
      var box = document.createElement('div');
      box.className = 'sp-rw-engine';
      box.setAttribute('data-sp-rw-engine', '');
      box.setAttribute('data-sp-rw-engine-box', '');
      box.setAttribute('aria-hidden', 'true');
      box.setAttribute('inert', '');
      box.style.cssText = 'position:fixed;left:0;bottom:0;width:420px;max-width:100vw;height:1px;overflow:hidden;opacity:0;pointer-events:none;z-index:-1;';
      var copy = document.importNode(block, true);
      Array.prototype.forEach.call(copy.querySelectorAll('script'), function (s) { s.parentNode.removeChild(s); });
      box.appendChild(copy);
      document.body.appendChild(box);
      Array.prototype.forEach.call(block.querySelectorAll('script:not([src])'), function (s) {
        var n = document.createElement('script'); n.textContent = s.textContent; document.body.appendChild(n);
      });
      /* Forms' scripts, in the order Shopify put them on the engine page */
      Array.prototype.forEach.call(doc.querySelectorAll('script[src]'), function (s) {
        var src = s.getAttribute('src') || '';
        if (!/\/extensions\/[^/]+\/forms-[^/]+\/assets\//.test(src)) return;
        if (document.querySelector('script[src="' + src + '"]')) return;
        var n = document.createElement('script');
        if (s.getAttribute('type')) n.type = s.getAttribute('type');
        n.async = false;
        n.src = src;
        document.head.appendChild(n);
      });
    });
    booting.catch(function () { booting = null; });
    return booting;
  }

  function tidy() {
    var box = document.querySelector('[data-sp-rw-engine-box]');
    if (box) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-sp-rw-engine]'), function (b) {
      if (!b.querySelector('shopify-forms-embed, [data-forms-id]')) return;
      b.setAttribute('data-sp-rw-engine-box', '');
      b.hidden = false;
      b.setAttribute('aria-hidden', 'true');
      b.setAttribute('inert', '');
      b.style.cssText = 'position:fixed;left:0;bottom:0;width:420px;max-width:100vw;height:1px;overflow:hidden;opacity:0;pointer-events:none;z-index:-1;';
    });
  }

  // Watch the page's own requests so a Forms submission can be confirmed by its response
  if (window.fetch && !window.fetch.__spRw) {
    var nativeFetch = window.fetch;
    var hooked = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var p = nativeFetch.apply(this, arguments);
      if (busy && method === 'POST' && /forms/i.test(url) && !/hcaptcha|analytics|monorail|telemetry|metrics/i.test(url)) {
        p.then(function (res) { if (res.ok) seen.ok++; else if (res.status >= 400 && res.status !== 429) seen.bad++; }, function () {});
      }
      return p;
    };
    hooked.__spRw = true;
    window.fetch = hooked;
  }

  function setVal(el, v) {
    if (!el) return false;
    var tag = el.tagName;
    if (tag === 'SELECT') {
      var pick = null;
      Array.prototype.forEach.call(el.options, function (o) {
        if (pick) return;
        var val = String(o.value).trim(), txt = String(o.textContent).trim();
        if (val === String(v) || txt === String(v) || (String(v).length === 1 && (val.charAt(0) === String(v) || txt.charAt(0) === String(v)))) pick = o;
      });
      if (!pick) return false;
      v = pick.value;
    }
    if (el.type === 'radio' || el.type === 'checkbox') {
      var group = root().querySelectorAll('input[name="' + el.name + '"]');
      var hit = null;
      Array.prototype.forEach.call(group, function (r) { if (!hit && (String(r.value) === String(v) || String(r.value).charAt(0) === String(v))) hit = r; });
      if (!hit) return false;
      if (!hit.checked) hit.click();
      return true;
    }
    var proto = tag === 'TEXTAREA' ? HTMLTextAreaElement.prototype : (tag === 'SELECT' ? HTMLSelectElement.prototype : HTMLInputElement.prototype);
    var desc = Object.getOwnPropertyDescriptor(proto, 'value');
    try { el.focus({ preventScroll: true }); } catch (e) {}
    if (desc && desc.set) desc.set.call(el, v); else el.value = v;
    el.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    el.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    el.dispatchEvent(new FocusEvent('blur', { composed: true }));
    el.dispatchEvent(new FocusEvent('focusout', { bubbles: true, composed: true }));
    return true;
  }

  function stepOf() { var s = q('[data-current-step]'); return s ? s.getAttribute('data-current-step') : ''; }
  function errorsShown() {
    var r = root();
    if (!r) return '';
    var msgs = [];
    Array.prototype.forEach.call(r.querySelectorAll('[aria-invalid="true"], [role="alert"]'), function (el) {
      if (el.getClientRects().length === 0) return;
      var t = (el.getAttribute('role') === 'alert' ? el.textContent : (el.getAttribute('aria-describedby') && r.getElementById(el.getAttribute('aria-describedby')) || {}).textContent || el.name || el.id) || '';
      t = String(t).trim();
      if (t) msgs.push(t);
    });
    return msgs.join(' | ');
  }
  function challengeOpen() {
    var frames = document.querySelectorAll('iframe[src*="hcaptcha"], iframe[title*="hCaptcha" i]');
    var r = root();
    var inner = r ? r.querySelectorAll('iframe[src*="hcaptcha"]') : [];
    var all = Array.prototype.slice.call(frames).concat(Array.prototype.slice.call(inner));
    return all.some(function (f) {
      var b = f.getBoundingClientRect();
      var st = window.getComputedStyle(f.parentNode || f);
      return b.width > 150 && b.height > 150 && st.visibility !== 'hidden' && st.display !== 'none' && st.opacity !== '0';
    });
  }
  // A security check shown by Forms would sit under the modal review dialog, so step the dialog out of the top layer
  function liftDialog() {
    var d = document.querySelector('dialog.sp-rw[open]');
    if (!d || d.hasAttribute('data-sp-rw-lifted')) return;
    var modal = true;
    try { modal = d.matches(':modal'); } catch (e) {}
    if (!modal) return;
    d.setAttribute('data-sp-rw-lifted', '');
    d.close();
    d.show();
    d.classList.add('is-in');
    document.documentElement.classList.add('sp-rw-lock');
  }

  function viaEmail(data) {
    var form = document.querySelector('dialog.sp-rw[open] [data-sp-rw-form]') || document.querySelector('[data-sp-rw-form]');
    if (!form) return Promise.reject(new Error('no-form'));
    try { sessionStorage.setItem('sp-rw-name', String(data.author || '').split(' ')[0]); } catch (e) {}
    HTMLFormElement.prototype.submit.call(form);
    return new Promise(function () {});
  }

  function viaForms(data) {
    tidy();
    return poll(function () { tidy(); return formEl() && field('email') ? formEl() : null; }, 20000).then(function (form) {
      var pid = String(data.productId || '').replace(/\D/g, '');
      if (!pid) throw new Error('no-product');
      var ok = setVal(field('email'), data.email) &&
        setVal(field('custom#product_id'), pid) &&
        setVal(field('custom#rating'), String(data.rating)) &&
        setVal(field('custom#review'), data.body) &&
        setVal(field('custom#name_shown'), data.author);
      if (!ok) throw new Error('fields');
      if (data.title) setVal(field('custom#headline'), data.title);
      return wait(250).then(function () {
        var before = stepOf();
        seen.ok = 0; seen.bad = 0;
        var btn = form.querySelector('button[type="submit"], input[type="submit"]') || form.querySelector('button:not([type="button"])');
        if (btn && !btn.disabled) btn.click();
        else if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true, composed: true }));
        var t0 = Date.now();
        var limit = 25000;
        var goneAt = 0;
        return poll(function () {
          var now = Date.now();
          if (challengeOpen()) { liftDialog(); limit = 240000; }
          if (seen.bad) throw new Error('rejected');
          var step = stepOf();
          var gone = !field('email');
          goneAt = gone ? (goneAt || now) : 0;
          if (seen.ok && (gone || step !== before)) return 'ok';
          if (step && step !== before && /success|complete|thank|done|submitted/i.test(step)) return 'ok';
          if (goneAt && now - goneAt > 1500 && /thank|received|success|submitted|sent/i.test(root() ? root().textContent : '')) return 'ok';
          if (now - t0 > 2500 && !seen.ok && !gone && errorsShown() && !challengeOpen()) throw new Error('invalid: ' + errorsShown());
          if (now - t0 > limit) throw new Error('timeout');
          return null;
        }, 245000, 200);
      });
    });
  }

  window.SPReviewEngine = {
    ready: function () { return !!formEl(); },
    /* start loading the form early (the review dialog calls this when it opens) */
    warm: function () { return boot().catch(function () {}); },
    send: function (data) {
      if (busy) return Promise.reject(new Error('busy'));
      busy = true;
      return boot().then(function () { return viaForms(data); }).then(function (r) {
        busy = false;
        return r;
      }, function (err) {
        busy = false;
        if (window.console) console.warn('[Suprimal reviews] Forms unavailable, sending by email:', err && err.message);
        return viaEmail(data);
      });
    }
  };

  /* the review dialog takes focus as it opens: start bringing the form in right then */
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('dialog.sp-rw, [data-sp-rw-form]')) boot().catch(function () {});
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tidy); else tidy();
  var mo = new MutationObserver(function () { tidy(); if (document.querySelector('[data-sp-rw-engine-box]')) mo.disconnect(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 15000);
})();